/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UserTaskStatus = {
    Open: 'Open',
    InProgress: 'InProgress',
    Completed: 'Completed',
    Cancelled: 'Cancelled'
} as const;
export type UserTaskStatus = typeof UserTaskStatus[keyof typeof UserTaskStatus];


export function instanceOfUserTaskStatus(value: any): boolean {
    for (const key in UserTaskStatus) {
        if (Object.prototype.hasOwnProperty.call(UserTaskStatus, key)) {
            if (UserTaskStatus[key as keyof typeof UserTaskStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UserTaskStatusFromJSON(json: any): UserTaskStatus {
    return UserTaskStatusFromJSONTyped(json, false);
}

export function UserTaskStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTaskStatus {
    return json as UserTaskStatus;
}

export function UserTaskStatusToJSON(value?: UserTaskStatus | null): any {
    return value as any;
}

export function UserTaskStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): UserTaskStatus {
    return value as UserTaskStatus;
}

